export default "__VITE_ASSET__BMqMa1JZ__"